export const addMessage = async ({ data, token }) => {
  let newEntry = await fetch(`${process.env.API_URL}/messages/add`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({
      ...data,
      title: data.subject,
      content: data.message,
    }),
  }).then((r) => r.json());
  return newEntry.data;
};

export const deleteMessage = async ({ data, token }) => {
  let deletedEntry = await fetch(`${process.env.API_URL}/messages/delete`, {
    method: 'DELETE',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify(data),
  }).then((r) => r.json());
  return deletedEntry.data;
};

export const getMessages = async ({ queryKey, meta }) => {
  const [_key, { limit = 10, page = 1, type = 'all' }] = queryKey;
  let data = await fetch(`${process.env.API_URL}/messages`, {
    method: 'POST',
    mode: 'cors',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${meta.token}`,
    },
    body: JSON.stringify({ limit, page, type }),
  }).then((r) => r.json());
  return data.data;
};
